import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";


export default (theme: APTheme) =>
  createStyles(
    (() => {
      const background =
        (theme.portal &&
          theme.portal.header &&
          theme.portal.header.background) ||
        "#333";

      const logo = (theme.portal && theme.portal.logo) || "";

      return {
        contactLogo: {
          backgroundSize: "auto 35px",
          backgroundPosition: "left center",
          backgroundRepeat: "no-repeat",
          backgroundImage: `url(${logo})`,
          flex: 1,
        },
        managerDetails: {
          [theme.breakpoints.down('md')]: {
            display: "block",
          },
          [theme.breakpoints.up("sm")]: {
            display: "grid",
          },
        },
        managerPhoto: {
          width: 92,
          height: 92,
          margin: "0 auto 10px",
          [theme.breakpoints.down('sm')]: {
            width: 75,
            height: 75,
            margin: "0 auto 10px",
          }
        },
        managerName: {
          margin: "0 auto",
          color: "#4A4A4A",
          fontSize: 16,
          fontWeight: 700,
          [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
          },
        },
        managerTitle: {
          margin: "0 auto 18px",
          color: "#A4A4A4",
          fontSize: 14,
          [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
          },
        },
        contactButton: {
          color: "#2D91E9",
          border: "1px solid #E8E8E8",
          background: "#FFF",
          display: "block",
          [theme.breakpoints.down('sm')]: {
            display: "none",
          },
          "&:hover": {
            background: "#FFF",
            border: "1px solid #2D91E9",
          },
        },
        contactContainer: {
          backgroundColor: background,
          padding: 20,
          [theme.breakpoints.down('sm')]: {
            padding: '5px 20px 0 20px',
          },
        },
        contactPullOutWrapper: {
          // '& span': {
          //     '&:before': {
          //       content: '""',
          //       display: 'block',
          //       width: '0',
          //       height: '0',
          //       position: 'absolute',
          //       borderTop: '10px solid transparent',
          //       borderBottom: '10px solid transparent',
          //       borderRight: '10px solid blue',
          //       left: '0px',
          //       top: '25px',
          //     }
          // }
        },
        contactPullOutContainer: {
          '& .MuiPopover-paper': {
            boxShadow: '0 5px 12px 0 rgba(0, 0, 0, 0.08)',
            maxWidth: 310,
            width: '100%',
            padding: '25px 30px 25px 30px',
            top: '120px !important',
            left: '295px !important',
            borderRadius: '4px',
            '&:before': {
              content: '""',
              display: 'block',
              width: '0',
              height: '0',
              position: 'absolute',
              borderTop: '10px solid transparent',
              borderBottom: '10px solid transparent',
              // borderRight: '10px solid blue',
              left: '0px',
              top: '25px',
              zIndex: '9998'
            }
          }
        },
        contactInfoSection: {
          '& h6': {
            fontFamily: 'CircularStd',
            fontSize: '16px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.75',
            letterSpacing: '-0.5px',
            color: '#4a4a4a',
            marginTop: '5px',
            marginBottom: '5px'
          }
        },
        userContact: {
          '& ul': {
            padding: '8px 0px 8px 0px',
            marginTop: '0px',
            marginBottom: '0px',
            listStyleType: 'none'
          },
          '& li': {
            fontFamily: 'CircularStd',
            fontSize: '14px',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.29',
            letterSpacing: '-0.5px',
            color: '#4a4a4a',
            wordBreak: 'break-word'
          },
          '& li:nth-child(even)': {
            marginBottom: '15px'
          }
        },
        userContactSource: {
          fontFamily: 'CircularStd',
          fontSize: '16px',
          fontWeight: 500,
          fontStretch: 'normal',
          fontStyle: 'normal',
          lineHeight: '1.13',
          letterSpacing: '-0.5px',
          color: '#2d91e9'
        },
        teamContact: {
          '& ul': {
            borderRadius: '3px',
            backgroundColor: '#f5f5f5',
            padding: '20px 21px 20px 21px',
            marginTop: '0px',
            marginBottom: '0px',
            listStyleType: 'none'
          },
          '& li': {
            fontFamily: 'CircularStd',
            fontSize: '14px',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.29',
            letterSpacing: '-0.5px',
            color: '#a4a4a4'
          },
          '& li:nth-child(even)': {
            marginBottom: '15px'
          },
          '& li:last-child': {
            marginBottom: 0
          }
        },
        teamContactSource: {
          fontFamily: 'CircularStd',
          fontSize: '16px',
          fontWeight: 500,
          fontStretch: 'normal',
          fontStyle: 'normal',
          lineHeight: '1.13',
          letterSpacing: '-0.5px',
          color: '#4a4a4a',
        },
        /*leftTriangle: {
          border: '1px solid red',
          height: 10,
          width: 10,
          position: 'absolute',
          top: '172px',
          left: '230px',
          'z-index': 9999,
        }*/
      };
    })()
  );
